import axios from 'axios';

import themeConfig from '@lib/themeConfig';

import { AclService } from '@service/acl';

// let Api = axios.create({
// 	baseURL: themeConfig.api.url,
// 	headers: {
// 		'Accept': 'application/json',
// 		'Content-Type': 'application/json',
// 	},
// })

// Api.interceptors.request.use(function (config) {
// 	const token = AclService.getToken('access_token')
// 	config.headers.Authorization = token ? `Bearer ${token}` : '';
// 	return config;
// })

// export default Api;


const conn = axios.create({
	baseURL: themeConfig.api.appUrl,
	// withCredentials: true,
	// withXSRFToken: true,
	headers: {
		"Accept": "application/json",
		"Content-Type": "application/json",
		"Authorization": `Bearer ${AclService.getToken('access_token')}`
	},
});

export default conn;